import {IconButton} from "@atlaskit/button/new";
import type {ComponentProps} from "react";

export function AnankeIconButton(
    props: ComponentProps<typeof IconButton> & {
        type: Exclude<ComponentProps<typeof IconButton>["type"], undefined>;
    },
) {
    return <IconButton {...props} />;
}
